module.exports = __webpack_public_path__ + "img/quakerpapagaj80.76b4ee2f.jpg";